// extracted by mini-css-extract-plugin
export default {"title":"_1db8511d56","bld":"e0701c4e32"};